/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import clsx from 'clsx'

type UiScrollAreaProps = {
    children: React.ReactNode
    className?: string
    maxHeightClass?: string
    size?: 'sm' | 'md'
    textSize?: 'xs' | 'sm' | 'md'
    id?: string
}

const UiScrollArea: React.FC<UiScrollAreaProps> = ({
    children,
    className,
    maxHeightClass = 'max-h-[70vh]',
    size = 'md',
    textSize = 'md',
    id,
}) => {
    const padding = size === 'sm' ? 'px-2 py-2' : 'px-3 py-3'
    const textClass =
        textSize === 'xs' ? 'text-xs' : textSize === 'sm' ? 'text-sm' : 'text-base'
    return (
        <div
            id={id}
            role="region"
            className={clsx(
                'UiScrollArea w-full overflow-y-auto',
                maxHeightClass,
                padding,
                textClass,
                'bg-white text-gray-900 dark:bg-gray-900 dark:text-gray-100',
                className
            )}
        >
            {children}
        </div>
    )
}

export default UiScrollArea
